import {
  PROJECT_SCHEDULE, PROJECT_SCHEDULE_CUSTOM_FIELDS,
} from './fragments';

import { API } from 'aws-amplify';

export default {
  createProjectColumn(variables) {
    const query = `
      mutation createProjectColumn (
        $columnName: String!
        $columnType: String!
        $scheduleId: String!
        $viewId: String!
        $workspaceId: String!
      ) {
        response: createProjectColumn (
          columnName: $columnName
          columnType: $columnType
          scheduleId: $scheduleId
          viewId: $viewId
          workspaceId: $workspaceId
        ) {
          ${PROJECT_SCHEDULE_CUSTOM_FIELDS}
        }
      }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  deleteProjectCustomColumn(variables) {
    const query = `
      mutation deleteProjectCustomColumn(
        $columnName: String!
        $projectId: String!
        $scheduleId: String!
        $workspaceId: String!
      ) {
        response: deleteProjectCustomColumn(
          columnName: $columnName
          projectId: $projectId
          scheduleId: $scheduleId
          workspaceId: $workspaceId
        ) {
          ${PROJECT_SCHEDULE}
        }
      }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  renameProjectCustomColumn(variables) {
    const query = `
      mutation renameProjectCustomColumn(
        $columnName: String!
        $newColumnName: String!
        $projectId: String!
        $scheduleId: String!
        $workspaceId: String!
      ) {
        response: renameProjectCustomColumn(
          columnName: $columnName
          newColumnName: $newColumnName
          projectId: $projectId
          scheduleId: $scheduleId
          workspaceId: $workspaceId
        ) {
          ${PROJECT_SCHEDULE}
        }
      }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
};
